export const StatusOptions = [
    {
        value: 1,
        name: "Active"
    },
    {
        value: 0,
        name: "Inactive"
    }
]